<input class="form-control dropdown-toggle"
    [disabled]="inputDisabled"
    [placeholder]="datePlaceholder"
    [class.is-invalid]="dateInvalid || (requireDate && (dateString === null || dateString === ''))"
    [ngModel]="dateString"
    [style]="{
        'pointer-events': blockInput ? 'none' : 'auto',
        'border-color': dateInvalid ? 'red' : ''
    }"
    (ngModelChange)="dateStringChanged($event)"
    (keydown.escape)="closeDatePickerOnKeyPress()"
    (keydown.enter)="closeDatePickerOnKeyPress()"
    (click)="toggleDatePicker()">
<div #singleDatePicker [ycnAppendToBody]="appendToBody" class="dropdown-menu" [ngClass]="{show: isOpen}">
    <div class="datepicker">
        <div class="datepicker-header">
            <a class="btn btn-transparent datepicker-nav datepicker-nav-prev"
               data-handler="prev"
               data-event="click"
               title="Prev"
               ycnDisabled [disabled]="selectedMonth === 0 && selectedYear === (startDate?.getFullYear() || startYear)"
               (click)="prevMonth()">
            </a>
            <div class="datepicker-title">
                <ycn-single-select-dropdown class="dropdown"
                    data-test-id="month-dropdown"
                    [config]="MONTH_DROPDOWN_CONFIG"
                    [customCssClasses]="{ button: 'btn btn-secondary btn-block style-underline', dropdownMenu: 'dropdown-menu-scrollable-xl'}"
                    [selectedValue]="selectedMonth"
                    (changeHandler)="monthChanged($event)">
                </ycn-single-select-dropdown>
                <ycn-single-select-dropdown class="dropdown"
                    data-test-id="year-dropdown"
                    [config]="yearDropdownConfig"
                    [customCssClasses]="{ button: 'btn btn-secondary btn-block style-underline', dropdownMenu: 'dropdown-menu-scrollable-xl'}"
                    [selectedValue]="selectedYear"
                    [scrollToSelected]="true"
                    (changeHandler)="yearChanged($event)">
                </ycn-single-select-dropdown>
            </div>
            <a class="btn btn-transparent datepicker-nav datepicker-nav-next"
               data-handler="next"
               data-event="click"
               title="Next"
               ycnDisabled
               [disabled]="selectedMonth === 11 && selectedYear === (endDate?.getFullYear() || endYear)"
               (click)="nextMonth()">
            </a>
        </div>
        <table class="datepicker-calendar">
            <thead>
                <tr>
                    <th class="datepicker-week-end" scope="col"><span title="Sunday">Su</span></th>
                    <th scope="col"><span title="Monday">Mo</span></th>
                    <th scope="col"><span title="Tuesday">Tu</span></th>
                    <th scope="col"><span title="Wednesday">We</span></th>
                    <th scope="col"><span title="Thursday">Th</span></th>
                    <th scope="col"><span title="Friday">Fr</span></th>
                    <th class="datepicker-week-end" scope="col"><span title="Saturday">Sa</span></th>
                </tr>
            </thead>
            <tbody>
                <tr>
                    <!--This row may contain some dates from the previous month-->
                    <td *ngFor="let dateItem of dateItems | slice:0:7; let i = index"
                        [ngClass]="{
                            'highlight-range': (dateItem | isDateItemWithinDateRange:this.selectedDateRange.startDate:this.selectedDateRange.endDate),
                            'highlight-yc-blue': (dateItem | isDateItemSelected:this.selectedDateRange.startDate) || (dateItem | isDateItemSelected:this.selectedDateRange.endDate)
                        }">
                        <span [ngClass]="{'datepicker-week-end': i === 0 || i == 6}">
                              <a *ngIf="dateItem.month === selectedMonth && (dateItem | isValidDateForDateRange:this.selectedDateRange.startDate:this.selectedDateRange.endDate:this.isStartOfRange:this.startDate:this.endDate);
                                  else disabled_date"
                                  [ngClass]="{'state-highlight': (dateItem | isDateItemSelected:this.selectedDate) ||
                                                                 (dateItem | isDateItemSelected:this.selectedDateRange.startDate) ||
                                                                 (dateItem | isDateItemSelected:this.selectedDateRange.endDate)}"
                                  class="state-default"
                                  href="javascript:void(0)"
                                  [textContent]="dateItem.day"
                                  (click)="this.dateSelected(dateItem)">
                              </a>
                              <ng-template #disabled_date>
                                    <span [ngClass]="{'state-highlight': (dateItem | isDateItemSelected:this.selectedDate) || (dateItem | isDateItemSelected:this.selectedDateRange.startDate) || (dateItem | isDateItemSelected:this.selectedDateRange.endDate)}"
                                        class="datepicker-other-month datepicker-unselectable state-disabled"
                                        [textContent]="dateItem.day">
                                    </span>
                              </ng-template>
                        </span>
                    </td>
                </tr>
                <!-- Create rows of date items that must be in the current month -->
                <tr *ngFor="let indexRange of middleRowDateItemIndexRanges">
                    <td *ngFor="let dateItem of dateItems | slice:indexRange.startIndex:indexRange.endIndex; let i = index"
                        [ngClass]="{
                              'highlight-range': (dateItem | isDateItemWithinDateRange:this.selectedDateRange.startDate:this.selectedDateRange.endDate),
                              'highlight-yc-blue': (dateItem | isDateItemSelected:this.selectedDateRange.startDate) || (dateItem | isDateItemSelected:this.selectedDateRange.endDate)
                        }">
                        <span [ngClass]="{'datepicker-week-end': i === indexRange.startIndex || i == indexRange.endIndex-1}">
                              <a *ngIf="(dateItem | isValidDateForDateRange:this.selectedDateRange.startDate:this.selectedDateRange.endDate:this.isStartOfRange:this.startDate:this.endDate);
                                 else disabled_date"
                                 [ngClass]="{ 'state-highlight': (dateItem | isDateItemSelected:this.selectedDate) || (dateItem | isDateItemSelected:this.selectedDateRange.startDate) || (dateItem | isDateItemSelected:this.selectedDateRange.endDate)}"
                                 class="state-default"
                                 href="javascript:void(0)"
                                 [textContent]="dateItem.day"
                                 (click)="this.dateSelected(dateItem)">
                              </a>
                              <ng-template #disabled_date>
                                    <span class="datepicker-other-month datepicker-unselectable state-disabled" [textContent]="dateItem.day">
                                    </span>
                              </ng-template>
                        </span>
                    </td>
                </tr>
                <tr>
                    <!-- This row may contain some dates from the next month-->
                    <td *ngFor="let dateItem of dateItems | slice:28:35; let i = index"
                        [ngClass]="{
                              'highlight-range': (dateItem | isDateItemWithinDateRange:this.selectedDateRange.startDate:this.selectedDateRange.endDate),
                              'highlight-yc-blue': (dateItem | isDateItemSelected:this.selectedDateRange.startDate) || (dateItem | isDateItemSelected:this.selectedDateRange.endDate)
                        }">
                        <span [ngClass]="{'datepicker-week-end': i === 28 || i == 34}">
                              <a *ngIf="dateItem.month === selectedMonth && (dateItem | isValidDateForDateRange:this.selectedDateRange.startDate:this.selectedDateRange.endDate:this.isStartOfRange:this.startDate:this.endDate);
                                  else disabled_date"
                                  [ngClass]="{'state-highlight': (dateItem | isDateItemSelected:this.selectedDate) || (dateItem | isDateItemSelected:this.selectedDateRange.startDate) || (dateItem | isDateItemSelected:this.selectedDateRange.endDate)}"
                                  class="state-default"
                                  href="javascript:void(0)"
                                  [textContent]="dateItem.day"
                                  (click)="this.dateSelected(dateItem)">
                              </a>
                              <ng-template #disabled_date>
                                    <span [ngClass]="{'state-highlight': (dateItem | isDateItemSelected:this.selectedDate) || (dateItem | isDateItemSelected:this.selectedDateRange.startDate) ||(dateItem | isDateItemSelected:this.selectedDateRange.endDate)}"
                                         class="datepicker-other-month datepicker-unselectable state-disabled"
                                         [textContent]="dateItem.day">
                                    </span>
                              </ng-template>
                        </span>
                    </td>
                </tr>
                <!-- Handles the case where we need an extra row to display all dates-->
                <tr *ngIf="this.dateItems.length === 42">
                    <!--This row may contain some dates from the next month-->
                    <td *ngFor="let dateItem of dateItems | slice:35:42; let i = index"
                        [ngClass]="{
                              'highlight-range': (dateItem | isDateItemWithinDateRange:this.selectedDateRange.startDate:this.selectedDateRange.endDate),
                              'highlight-yc-blue': (dateItem | isDateItemSelected:this.selectedDateRange.startDate) || (dateItem | isDateItemSelected:this.selectedDateRange.endDate)
                        }">
                        <span [ngClass]="{'datepicker-week-end': i === 35 || i == 41}">
                              <a *ngIf="dateItem.month === selectedMonth && (dateItem | isValidDateForDateRange:this.selectedDateRange.startDate:this.selectedDateRange.endDate:this.isStartOfRange:this.startDate:this.endDate);
                                  else disabled_date"
                                  [ngClass]="{'state-highlight': (dateItem | isDateItemSelected:this.selectedDate) || (dateItem | isDateItemSelected:this.selectedDateRange.startDate) || (dateItem | isDateItemSelected:this.selectedDateRange.endDate)}"
                                  class="state-default"
                                  href="javascript:void(0)"
                                  [textContent]="dateItem.day"
                                  (click)="this.dateSelected(dateItem)">
                              </a>
                              <ng-template #disabled_date>
                                    <span [ngClass]="{'state-highlight': (dateItem | isDateItemSelected:this.selectedDate) || (dateItem | isDateItemSelected:this.selectedDateRange.startDate) || (dateItem | isDateItemSelected:this.selectedDateRange.endDate)}"
                                        class="datepicker-other-month datepicker-unselectable state-disabled"
                                        [textContent]="dateItem.day">
                                    </span>
                              </ng-template>
                        </span>
                    </td>
                </tr>
            </tbody>
        </table>
    </div>
</div>
@if (requireDate && (dateString === null || dateString === '')) {
    <div class="mb-1">
        <div class="feedback feedback-invalid">Custom date must be set.</div>
    </div>
}
